import { Col, Modal, Row } from "antd"
import moment from "moment"
import React from "react"
import { useTranslation } from "react-i18next"

import VendorImage from "Components/VendorImage"
import { VendorService } from "Shared/services"
import { Expense } from "@finway-group/shared/lib/models"

interface SubscriptionHistoryModalInterface {
    isVisible: boolean
    subscription: Expense
    onCancel: (state: false) => void
}
const SubscriptionHistoryModal: React.FC<SubscriptionHistoryModalInterface> = ({ isVisible, subscription, onCancel }) => {
    const { t } = useTranslation()

    return (
        <Modal
            title={t("action:request.subscription_history")}
            visible={isVisible}
            maskClosable={false}
            onCancel={() => onCancel(false)}
            cancelText={t("action:cancel_subscription_history")}
            keyboard
            destroyOnClose
            okButtonProps={{ style: { display: "none" } }}
        >
            {subscription.pauseIntervals?.map((interval: any, index: number) => {
                const vendor = VendorService.getVendorById(subscription.vendor)
                return (
                    <Row key={index}>
                        <Row gutter={[0, 16]}>
                            <Col span={3}>
                                <VendorImage size={"large"} vendor={vendor} />
                            </Col>
                        </Row>
                        <Col span={21}>
                            <Row gutter={[16, 16]}>
                                <Col span={11} className="pr-10">
                                    <Row>
                                        <div className="text-text-dark font-bold truncate">{subscription.name}</div>
                                    </Row>
                                    <Row>
                                        <div className="text-sm sm:text-base leading-tight truncate">{subscription.description}</div>
                                    </Row>
                                </Col>
                                <Col span={6} offset={1}>
                                    <Row className="text-text">{t("label:paused_on")}</Row>
                                    <Row>
                                        <div className="leading-tight">{moment(interval.datePauseStarted).format("ll")}</div>
                                    </Row>
                                </Col>
                                <Col span={6}>
                                    {interval.datePauseEnded && (
                                        <>
                                            <Row className="text-text">{t("label:resumed_on")}</Row>
                                            <Row>
                                                <div className="leading-tight">{moment(interval.datePauseEnded).format("ll")}</div>
                                            </Row>
                                        </>
                                    )}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                )
            })}
        </Modal>
    )
}

export default SubscriptionHistoryModal
